import { Redirect, Route, Switch } from "react-router-dom";
/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";

import {
  AppBar,
  Book,
  BookSidebar,
  ImageCarousel,
  Order,
  OrderSidebar,
  Overview,
  Events,
  OverviewSidebar,
  QGFooter,
  ReservationDetails,
  RestaurantInfo,
  Waitlist,
  WaitlistDetails,
  WaitlistSidebar,
} from "pages/restaurant/routes";

import Tabs from "../components/tabs";

// import ChatBot from "pages/restaurant/ChatBot.jsx";

const Root = styled.div({
  position: "relative",
});

const Content = styled.div((props) => ({
  maxWidth: props.theme.bp.lessThan.lg ? "100%" : 1000,
  margin: "0 auto",
  marginTop: 4,
  display: "flex",
  justifyContent: "center",
}));
const Main = styled.div({
  width: "64%",
  maxWidth: 7000,
  marginRight: 8,
  zIndex: 1,
});
const Sidebar = styled.div({
  width: "36%",
  maxWidth: 350,
});

const Desktop = () => {
  return (
    <Root>
      <AppBar />
      <ImageCarousel />

      <Content>
        <Main>
          <div css={{ marginBottom: 8, borderRadius: 4 }}>
            <RestaurantInfo />
            <Tabs />
          </div>

          <Switch>
            <Route path="/:id/overview">
              <Overview />
            </Route>
            <Route path="/:id/web-delivery">
              <Order />
            </Route>
            <Route path="/:id/order">
              <Order />
            </Route>
            <Route exact path="/:id/book/:reservationUid">
              <ReservationDetails />
            </Route>
            {/* <Redirect from="/booking/:id" to="/:id/book" /> */}
            <Route path="/booking/:id">
              <Book />
            </Route>
            <Route path="/:id/book">
              <Book />
            </Route>
            <Route exact path="/:id/waitlist/:waitlistUid">
              <WaitlistDetails />
            </Route>
            <Route path="/:id/waitlist">
              <Waitlist />
            </Route>
            <Route path="/:id/events">
              <Events />
            </Route>
            <Redirect from="/:id" to="/:id/overview" />
          </Switch>
        </Main>

        <Sidebar>
          <Switch>
            <Route path="/:id/order">
              <OrderSidebar />
            </Route>
            <Route exact path="/:id/book/:reservationUid">
              <BookSidebar />
            </Route>
            <Route path="/:id/book">
              <BookSidebar />
            </Route>
            <Route path="/:id/waitlist">
              <WaitlistSidebar />
            </Route>
            <Route path="/:id/*">
              <OverviewSidebar />
            </Route>
          </Switch>
        </Sidebar>
      </Content>

      <QGFooter />
      {/* <ChatBot /> */}
    </Root>
  );
};

export default Desktop;
